export const checkForUpdatesHelper = async (
  url,
  setIsLoading,
  setServiceData
) => {
  setIsLoading(true);

  let options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await fetch('/' + url, options);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    if (Array.isArray(data)) {
      setServiceData(data);
    } else {
      setServiceData([]);
    }
  } catch (error) {
    console.error('Fetch error:', error);
  } finally {
    setIsLoading(false);
  }
};
